.listItem {
    border: none;
    border-bottom: 1px solid rgb(var(--color-black-base), 0.25);
    cursor: pointer;
    list-style: none;
    padding: 1.125rem 1.125rem 1.125rem 0;

    &:hover {
        background: #efefef;
    }
}

.mapButton {
    display: grid;
    grid-template-columns: 141px 1fr;
    width: 100%;
    background: none;
    border: none;
    align-items: center;
}

.glyphWrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.distance {
    font-size: 1.3125rem;
}

.detailsWrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.address {
    text-align: justify;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1;
}

.phone {
    font-size: 1.125rem;
}

.link {
    justify-content: center;
}

.button {
    composes: roundButton from "../../styles/buttons.module.scss";
}
